import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQueryWithPwPrefix } from 'store/middleware/pwContextMiddleware';

import type { ContentPageRequest, ContentPageResponse } from '../models/contentPageAPI';

export const contentPageAPI = createApi({
  reducerPath: 'contentPageAPI',
  baseQuery: createBaseQueryWithPwPrefix('/'),
  endpoints(builder) {
    return {
      contentPage: builder.query<ContentPageResponse, ContentPageRequest>({
        query: ({ url }) => ({
          url,
          method: 'GET',
          headers: {
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            Pragma: 'no-cache',
          },
        }),
      }),
    };
  },
});

export const { useLazyContentPageQuery } = contentPageAPI;
export default contentPageAPI.reducer;
